export default __webpack_public_path__ + "static/1525-ae59896f95095106c1126714cecb268f.gif";